import KPIsOrders from "../Components/Orders/KPIsOrders";
import ScoreOverlay from "../Components/UI/ScoreOverlay";
import { useState, useRef } from "react";
import OptimalOrder from "../Components/Orders/OptimialOrder";
import { useNavigate } from "react-router-dom";
import { useStopwatch } from 'react-timer-hook';
import InfoBox from "../Components/UI/InfoBox";
import info from "../Components/images/info.png";
import { Trans, useTranslation } from "react-i18next";

function BigRedButtonPage (props) {
    props.calc();
    const { t } = useTranslation();

    //navigate with Button
    const navigate = useNavigate();

    function navigateHandler () {
        navigate("/5");
    }

    //OnClickHandler
    function onClickHandler () {
        pause();
    }

    //Optimize
    let buttonRef = useRef();
    const [optimize, setOptimize] = useState(false);
    const [loading, setLoading] = useState(false)
    function optimizeHandler () {
        setLoading(false);
        setOptimize(true);
        pause();

        if (buttonRef.current) {
            buttonRef.current.setAttribute("disabled", "disabled");
        }

    }

    const {
        seconds,
        minutes,
        start,
        pause,
        isRunning,
    } = useStopwatch({autoStart: false})

    const time = <div><span>{minutes}</span><span>:</span><span>{(seconds === 0 || seconds < 10) ? ("0" + seconds) : seconds}</span></div>

    function startTime() {
        if (!isRunning) {
            start();
        }
    }

    //Infobox
    const [boxStyle, setBoxStyle] = useState({display: "none"});
    const [buttonStyle, setButtonStyle] = useState({display: ""});
    function showInfoBox() {
        setBoxStyle({display: ""});
        setButtonStyle({display: "none"});
    }

    function hideInfoBox() {
        setBoxStyle({display: "none"});
        setButtonStyle({display: ""});
    }

    return (
        <div>
        {!optimize && <ScoreOverlay onClick={navigateHandler} score={props.orders.score} time={time} />}
        <div className="container-md case">
            <Trans>
            <h2>4. {t("brb")}</h2>
            <p>{t("brb_text1")}</p>
            <p><strong>{t("brb_text2")}</strong></p>
            </Trans>
            <div>
                {optimize && <OptimalOrder isMobile={props.isMobile} />}
                {!optimize && <KPIsOrders data={props.orders} calc={props.calc} startTime={startTime} isMobile={props.isMobile} />}
            </div>
            <div className="button-div">
            <button type="button" className="btn-lg optimize" onClick={()=>{setInterval(optimizeHandler, 3000); setLoading(true)}} ref={buttonRef} >{loading ? <div className="loader"></div> : "Optimize"}</button>
            </div>
            <div></div>
            <p>{t("brb_text4")}  &#x1F609;.</p>
            <button onClick={showInfoBox} className="infoButton" style={buttonStyle}><img src={info} width={25} height={25} alt="info"/></button>
            <InfoBox style={boxStyle} hideInfoBox={hideInfoBox}></InfoBox>
            <div className="button-div">
                {!optimize && <button onClick={onClickHandler} type="button" className="button" data-bs-toggle="modal" data-bs-target="#scoreModal">{t("finished")}</button>}
                {optimize && <button onClick={onClickHandler} type="button" className="button" data-bs-toggle="modal" data-bs-target="#scoreModal">{t("finished")}</button>}
                {optimize && <ScoreOverlay onClick={navigateHandler} score={1400} time={time}/>}
            </div>
        </div>
        </div>
    );
};

export default BigRedButtonPage;